theme.CartDrawerActions = (function() {
   function cartActions(){
     if (document.documentElement.dataset.lrCartActionsReady) return;
     document.documentElement.dataset.lrCartActionsReady = 'true';
     let cartActionsButtons = document.querySelectorAll('.cart_notification_action_button'),
      cartCancelButtons = document.querySelectorAll('.action_drawer_footer .button__cancel'),
      cartSaveButtons = document.querySelectorAll('.action_drawer_footer .button__save'),
      cartNoteData = document.getElementById('cartNote'),
      actionOverlay = document.querySelector('.cart_action_drawer_overlay'),
      cartNote = document.getElementById('cart_note_drawer'),
      ShippingCalc = document.getElementById('shipping_drawer'),
      shippingCountry = document.getElementById('AddressCountry_Shipping'),
      countryState = document.getElementById('AddressProvince_shipping'),
      shippingCountryZip = document.getElementById('ShippingAddressZip');

     const syncCartNote = () => {
       cartNoteData = document.getElementById('cartNote');
       if (!cartNoteData) return;
       fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
         .then(response => { if (!response.ok) throw new Error('Cart note read failed'); return response.json(); })
         .then(cart => {
           if (document.activeElement !== cartNoteData) cartNoteData.value = cart.note || '';
         })
         .catch(() => { /* Keep the server-rendered note available. */ });
     };
     syncCartNote();

     document.addEventListener('click', (event) => {
       const item = event.target.closest('.cart_notification_action_button, .action_drawer_footer .button__cancel, .action_drawer_footer .button__save');
       if (!item) return;
       event.preventDefault();
       cartNoteData = document.getElementById('cartNote');
       cartNote = document.getElementById('cart_note_drawer');
       actionOverlay = document.querySelector('.cart_action_drawer_overlay');
       if (item.classList.contains('cart_notification_action_button')) {
         if (item.dataset.drawer === 'note') {
           syncCartNote();
           cartNote.classList.add('active');
         } else {
           ShippingCalc.classList.add('active');
         }
         actionOverlay.classList.add('active');
         return;
       }
       if (item.classList.contains('button__cancel')) {
         (item.dataset.action === 'note' ? cartNote : ShippingCalc).classList.remove('active');
         actionOverlay.classList.remove('active');
         return;
       }
       if (item.disabled) return;
      if(item.dataset.action === "note"){                      
        let noteUpdate = cartNoteData.value;
        item.classList.add('loading');
        item.disabled = true;
        const noteError = document.getElementById('cartNoteError');
        if (noteError) noteError.hidden = true;
        let body = JSON.stringify({
          note: noteUpdate
       });
       fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
         .then((response) => {
            if (!response.ok) throw new Error('Cart note save failed');
            return response.json();
         })
         .then((state) => {
            if (state.status || typeof state.note !== 'string' && state.note !== null) throw new Error('Cart note save failed');
            cartNoteData.value = state.note || '';
            const fullCartNote = document.getElementById('Cart-note');
            if (fullCartNote) fullCartNote.value = state.note || '';
            cartNote.classList.remove('active');
            actionOverlay.classList.remove('active');
         })
         .catch(() => {
            if (noteError) {
              noteError.textContent = noteError.dataset.errorMessage;
              noteError.hidden = false;
            }
         })
         .finally(() => {
            item.classList.remove('loading');
            item.disabled = false;
         });
		}
      	if(item.dataset.action === "shipping"){
         let shippingRatePackage = document.querySelector('.shipping_rate_package');
         let shippingAddressWrapper = document.querySelector('.shipping_rate_message');
      	 let shippingAddressCount = document.querySelector('.shipping_address_count');
          
      	 shippingRatePackage.innerHTML = '';
          if(shippingCountry.value !== "---"){
            item.classList.add('loading');  
            fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${shippingCountryZip.value}&shipping_address%5Bcountry%5D=${shippingCountry.value}&shipping_address%5Bprovince%5D=${countryState.value}`)
            .then((response) => {
              if (response.ok) {
                return response.json()
              } else {
                throw `${window.shipping.wrong_message}`;
              }
            })
            .then((response) => {
              item.classList.remove('loading'); 
              
              shippingAddressWrapper.classList.remove('no-js-inline');
              shippingAddressCount.innerText = `${response.shipping_rates.length}`
              response.shipping_rates.map((item) => {
                let text = document.createElement("P"); 
                text.setAttribute("class", 'mb-0');
                text.innerText = `${item.name}: ${shopCurrencySymbol}${item.price}`
                shippingRatePackage.appendChild(text);
              })
            })
            .catch((e) => {
              item.classList.remove('loading');     
              shippingAddressWrapper.classList.add('no-js-inline');
              shippingRatePackage.innerHTML = `<p class="error mt-15">${e}</p>`;
            });
          }else{
            shippingAddressWrapper.classList.add('no-js-inline');
            shippingRatePackage.innerHTML = `<p class="error mt-15">${window.shipping.country_label}</p>`;
          }
    	} 
    });

	
	let countrySelectsShipping = document.querySelectorAll('data-address-country-select')
    if(shippingCountry && countryState){
      if (Shopify && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector('AddressCountry_Shipping', 'AddressProvince_shipping', {
          hideElement: 'AddressProvinceContainerNewShiping'
        });
      }
    }

   }
  return cartActions;
})();